/* This file is autogenerated, see readme.md for instructions */
import LinkSvgIcon from '@bloomreach/banana-theme/icons/link.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LinkIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LinkSvgIcon />
    </Icon>
  );
});

LinkIcon.displayName = 'LinkIcon';

export default LinkIcon;
